import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../Context/GlobalContext";

const HelpGuide = () => {
  const { getFaqList, faqList, translatedLabels } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  useEffect(() => {
    getFaqList();
  }, [getFaqList]);

  return (
    <div className="content-part">
      <div>
        <div className="accordion" id="faqListHolder">
          {faqList && faqList.length > 0 ? (
            faqList.map((faq, index) => {
              const isFirst = index === 0;
              return (
                <div
                  className="accordion-item mb-3 border rounded"
                  key={faq.id}
                >
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button
                      className={`accordion-button gap-2 pointer-cursor  ${
                        isFirst ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={isFirst ? "true" : "false"}
                      aria-controls={`collapse${index}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${
                      isFirst ? "show" : ""
                    }`}
                    aria-labelledby={`heading${index}`}
                    data-bs-parent="#faqListHolder"
                  >
                    <div className="accordion-body faq-answer-text py-2">
                      <div
                        className="mb-0 accordian-desc"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center">
              {screenLabels?.no_data_found?.label_value || "No Data Found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpGuide;
